module.exports = __webpack_public_path__ + "static/media/Combined Shape-2@1.5x.f8c0c8cc.svg";